{
  "backButton": "חזור אל {prevMenuButton}",
  "moreActions": "פעולות נוספות",
  "unavailable": "לא זמין, הרחב לפרטים"
}
